import React from 'react'
import { Form} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { questionActions } from '../../../../../store/slices/question.slice'
import QuestionForm from './QuestionForm'
import ResizableDrawer from '../../../../../components/common/resizable-drawer/ResizableDrawer'
import questionSelectors from '../../../../../store/selectors/question.selectors'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import { useFetchQuestionsQuery, useCreateQuestionMutation } from '../../../../../store/apis/question.api'

const CreateQuestionDrawer = () => {
    const showCreateQuestionDrawer = useSelector(questionSelectors.showCreateQuestionDrawer)
    const dispatch = useDispatch()
    const { token } = useParams()
    const versionId = useVersionId()
    const [form] = Form.useForm()

    const { data: questions } = useFetchQuestionsQuery({ token, versionId })
    const [createQuestion, { isLoading: isCreating, error }] = useCreateQuestionMutation()

    const handleClose = () => {
        dispatch(questionActions.setShowCreateQuestionDrawer(false))
    }

    const handleSubmit = async (values) => {
        try {
            await createQuestion({
                token,
                question: values
            }).unwrap()
            
            dispatch(questionActions.setShowCreateQuestionDrawer(false))
            return true
        } catch (error) {
            return false
        }
    }

    const content = (
            <QuestionForm
                onSubmit={handleSubmit}
                error={error?.data?.message}
                loading={isCreating}
                questions={questions}
                earlierQuestions={questions}
                form={form}
                submitButtonText="Create"
            />
    )

    if (!showCreateQuestionDrawer) return null

    return (
        <ResizableDrawer
            title='Create question'
            open
            autoFocus
            onClose={handleClose}
            mask={null}
        >
            {content}
        </ResizableDrawer>
    )
}

export default CreateQuestionDrawer 